import React from "react";
import { useParams } from "react-router-dom";
import {
  useWorkShop,
  WorkshopProvider,
} from "../../../../../contexts/workshop-context/WorkshopContext";
import SideBar from "../components/side-bar/SideBar";
import SubSection from "../components/sub-section/SubSection";
import Summary from "../components/summary/Summary";
import "./styles.scss";

interface IProps {
  id: string;
  isArchived: boolean;
}

const Workshop = (props: IProps) => {
  const workshop = useWorkShop();
  return (
    <div className="new-workshop-wrapper">
      <div className="new-workshop-sidebar">
        <SideBar isArchived={props.isArchived} />
      </div>
      <div className="new-workshop-content">
        {workshop.selectedSubSection.orderNo === -1 ? (
          <Summary isArchived={props.isArchived} />
        ) : (
          <SubSection isArchived={props.isArchived} />
        )}
      </div>
    </div>
  );
};

interface IPropsStudentWorkshop {
  isArchived: boolean;
}

const StudentWorkshop = (props: IPropsStudentWorkshop) => {
  const { id } = useParams() as any;
  return (
    <WorkshopProvider
      workshopId={id}
      isArchived={props.isArchived}
      isDireactArchived={false}
    >
      <Workshop id={id} isArchived={props.isArchived} />
    </WorkshopProvider>
  );
};

export default StudentWorkshop;
